import React, { Component } from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import PropTypes from 'prop-types'
import Fade from 'react-reveal/Fade'
import NewsletterSignUp from '../NetlifyExpressContactForm'
import styled from 'styled-components'
import facebook from '../../img/social/logo-facebook.svg'
import instagram from '../../img/social/logo-instagram.svg'
import youtube from '../../img/social/logo-youtube.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../utils/fontawesome'

{/*
export const FooterTemplate = ({ data }) => {
*/}

export class FooterTemplate extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showDetail: false,
      id: null,
      showAboutLinks: false,
      showExploreLinks: false,
      showHelpLinks: false,
      showPrivacyLinks: false,
    }
  }

  showAboutLinks = (e) => {
    e.preventDefault()
    this.setState({
      showAboutLinks: !this.state.showAboutLinks
    });
  }

  showExploreLinks = (e) => {
    e.preventDefault()
    this.setState({
      showExploreLinks: !this.state.showExploreLinks
    });
  }

  showHelpLinks = (e) => {
    e.preventDefault()
    this.setState({
      showHelpLinks: !this.state.showHelpLinks
    });
  }

  showPrivacyLinks = (e) => {
    e.preventDefault()
    this.setState({
      showPrivacyLinks: !this.state.showPrivacyLinks
    });
  }

  render () {
  const { data } = this.props
  const { mainpitch } = data

  return (
    <div style={{ position: 'relative' }}>
      <footer className='footer' style={{ background: '#161c27' }}>
        <div className='content has-text-centered'>
          <Img fixed={mainpitch.logo.childImageSharp.fixed} alt='Logo' style={{ width: '150px' }} />
        </div>

        <DesktopLinks>
          <div className='columns is-mobile is-multiline is-marginless is-paddingless'>
            <div className='column is-3'>
              <div style={{ width: '100px', textAlign: 'left', margin: '0 auto' }}>
                <h4 className='subtitle is-6' style={{ margin: '0px' }}>
                  Über uns
                </h4>
                <Link to='/' className='has-text-primary'>Unternehmen</Link>
                <br />
                <Link to='/' className='has-text-primary'>Team</Link>
                <br />
                <Link to='/' className='has-text-primary'>Nachhaltigkeit</Link>
                <br />
                <Link to='/' className='has-text-primary'>Jobs</Link>
              </div>
            </div>

            <div className='column is-3'>
              <div style={{ width: '100px', textAlign: 'left', margin: '0 auto' }}>
                <h4 className='subtitle is-6' style={{ margin: '0px' }}>
                  Entdecken
                </h4>
                <Link to='/blog' className='has-text-primary'>Blog</Link>
                <br />
                <Link to='/' className='has-text-primary'>Produkte</Link>
                <br />
                <Link to='/' className='has-text-primary'>Kollektionen</Link>
              </div>
            </div>

            <div className='column is-3'>
              <div style={{ width: '100px', textAlign: 'left', margin: '0 auto' }}>
                <h4 className='subtitle is-6' style={{ margin: '0px' }}>
                  Hilfe & Support
                </h4>
                <Link to='/' className='has-text-primary'>FAQ</Link>
                <br />
                <Link to='/' className='has-text-primary'>Kontaktadresse</Link>
                <br />
                <Link to='/' className='has-text-primary'>Email</Link>
                <br />
                <Link to='/' className='has-text-primary'>Telefon</Link>
                <br />
                <Link to='/' className='has-text-primary'>Social</Link>
                <br />
                <Link to='/' className='has-text-primary'>Größentabelle</Link>
                <br />
                <Link to='/' className='has-text-primary'>Garantie</Link>
              </div>
            </div>

            <div className='column is-3'>
              <div style={{ width: '100px', textAlign: 'left', margin: '0 auto' }}>
                <h4 className='subtitle is-6' style={{ margin: '0px' }}>
                  Rechtliches
                </h4>
                <Link to='/' className='has-text-primary'>AGB</Link>
                <br />
                <Link to='/' className='has-text-primary'>Impressum</Link>
                <br />
                <Link to='/' className='has-text-primary'>Datenschutz</Link>
              </div>
            </div>
          </div>


        </DesktopLinks>

        <MobileExpander onClick={this.showAboutLinks}>
          <h4 className='subtitle is-6' style={{ display: 'inline-block', margin: '0px' }}>
            Über uns
          </h4>
          {this.state.showAboutLinks ? <FontAwesomeIcon onClick={this.showAboutLinks} icon='minus' className='has-text-primary is-pulled-right' /> : <FontAwesomeIcon onClick={this.showAboutLinks} icon='plus' className='has-text-primary is-pulled-right' /> }

          <Fade collapse when={this.state.showAboutLinks}>
            <Link to='/' className='has-text-primary'>Unternehmen</Link>
            <Link to='/' className='has-text-primary'>Team</Link>
            <Link to='/' className='has-text-primary'>Nachhaltigkeit</Link>
            <Link to='/' className='has-text-primary'>Jobs</Link>
          </Fade>
        </MobileExpander>

        <MobileExpander onClick={this.showExploreLinks}>
          <h4 className='subtitle is-6' style={{ display: 'inline-block', margin: '0px' }}>
            Entdecken
          </h4>
          {this.state.showExploreLinks ? <FontAwesomeIcon onClick={this.showExploreLinks} icon='minus' className='has-text-primary is-pulled-right' /> : <FontAwesomeIcon onClick={this.showExploreLinks}
          icon='plus' className='has-text-primary is-pulled-right' /> }

          <Fade collapse when={this.state.showExploreLinks}>
            <Link to='/Blog' className='has-text-primary'>Blog</Link>
            <Link to='/' className='has-text-primary'>Produkte</Link>
            <Link to='/' className='has-text-primary'>Kollektionen</Link>
          </Fade>
        </MobileExpander>

        <MobileExpander onClick={this.showHelpLinks}>
          <h4 className='subtitle is-6' style={{ display: 'inline-block', margin: '0px' }}>
            Hilfe & Support
          </h4>
          {this.state.showHelpLinks ? <FontAwesomeIcon onClick={this.showHelpLinks} icon='minus' className='has-text-primary is-pulled-right' /> : <FontAwesomeIcon onClick={this.showHelpLinks}
          icon='plus' className='has-text-primary is-pulled-right' /> }

          <Fade collapse when={this.state.showHelpLinks}>
            <Link to='/' className='has-text-primary'>FAQ</Link>
            <Link to='/' className='has-text-primary'>Kontaktadresse</Link>
            <Link to='/' className='has-text-primary'>Email</Link>
            <Link to='/' className='has-text-primary'>Telefon</Link>
            <Link to='/' className='has-text-primary'>Social</Link>
            <Link to='/' className='has-text-primary'>Größentabelle</Link>
            <Link to='/' className='has-text-primary'>Garantie</Link>
          </Fade>
        </MobileExpander>

        <MobileExpander onClick={this.showPrivacyLinks}>
          <h4 className='subtitle is-6' style={{ display: 'inline-block', margin: '0px' }}>
            Rechtliches
          </h4>
          {this.state.showPrivacyLinks ? <FontAwesomeIcon onClick={this.showPrivacyLinks}
          icon='minus' className='has-text-primary is-pulled-right' /> : <FontAwesomeIcon onClick={this.showPrivacyLinks} icon='plus' className='has-text-primary is-pulled-right' /> }

          <Fade collapse when={this.state.showPrivacyLinks}>
            <Link to='/' className='has-text-primary'>AGB</Link>
            <Link to='/' className='has-text-primary'>Impressum</Link>
            <Link to='/' className='has-text-primary'>Datenschutz</Link>
          </Fade>
        </MobileExpander>
        <NewsletterWrapper>
          <NewsletterSignUp />
        </NewsletterWrapper>

        <div>
          <h1 className='title has-text-centered' style={{ letterSpacing: '3px', marginTop: '2rem' }}>{mainpitch.title}</h1>
          <h2 class='subtitle has-text-centered'>{mainpitch.subtitle}</h2>
        </div>
        <div className='column'>
          <div className='column get-in-touch-social-footer has-text-centered'>
            <a href='https://www.youtube.com/'>
              <img
                className='social-icon'
                src={youtube}
                alt='Youtube Link'
              />
            </a>

            <a href='https://www.facebook.com/'>
              <img
                className='social-icon'
                src={facebook}
                alt='Facebook Link'
              />
            </a>

            <a href='https://www.instagram.com/'>
              <img
                className='social-icon'
                src={instagram}
                alt='Instagram Link'
              />
            </a>
          </div>
        </div>

        <div className='column'>
          <div className='has-text-centered'>
            <p style={{ color: 'white', opacity: '0.6' }}>©{' '}{mainpitch.copyright}{' '}{new Date().getFullYear()}</p>
          </div>
        </div>
      </footer>
    </div>
  )
  }
}

const Footer = props => {
  if (!props.data) {
    return null
  }
  const data = props.data.edges[0].node.frontmatter
  return <FooterTemplate data={data} />
}

export { Footer }


const DesktopLinks = styled.div`
  display: none;
  @media(min-width: 779px){
    display: block;
    max-width: 1400px;
    margin: 4rem auto;
`

const MobileExpander = styled.div`
  display: none;
  @media(max-width: 779px){
    display: block;
    padding: 10px;
    border-top: 1px solid grey;
    border-bottom: 1px solid grey;
    overflow: hidden;
    &:hover{
      cursor: pointer;
    }
  }
`

const NewsletterWrapper = styled.div`
  margin: 3rem auto;
  max-width: 350px;
`
